import { gql } from '@apollo/client';

export * from './addUser.mutation.generated';

export const ADD_USER = gql`
  mutation addUser($users: [UserInput!]!) {
    addUser(input: { users: $users }) {
      success
      errors
      users {
        id
      }
    }
  }
`;
